'use client';

import { useEffect } from 'react';

import { captureExceptionLazy } from '@/lib/sentry/lazy';

/**
 * Global error boundary for root layout errors.
 * This catches errors that occur in the root layout itself.
 * Matches the legacy ErrorBoundary design.
 */
export default function GlobalError({
  error,
  reset: _reset
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    captureExceptionLazy(error);
  }, [error]);

  // Log to console in production too - this is a critical error
  // eslint-disable-next-line no-console
  console.error('[GlobalError] Critical error in root layout', error);

  return (
    <html lang="en">
      <body>
        <div
          style={{
            padding: '2rem',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            fontFamily: 'system-ui, sans-serif'
          }}
        >
          {}
          <img
            src="https://paction-shared-resources.s3.ca-central-1.amazonaws.com/common/error-image.png"
            alt="error image"
            style={{ height: '20rem', marginBottom: '1rem' }}
          />
          <h1
            style={{
              display: 'flex',
              flexDirection: 'column',
              textAlign: 'center',
              marginBottom: '2rem',
              lineHeight: '2.25rem'
            }}
          >
            <span>Nobody&apos;s pawfect!</span>
            We&apos;ll get this back online soon.
          </h1>
          <button
            onClick={() => window.history.back()}
            style={{
              height: '3rem',
              width: '10rem',
              fontSize: '1.25rem',
              backgroundColor: 'var(--color-primary, #4f46e5)',
              color: 'white',
              border: 'none',
              borderRadius: '0.5rem',
              cursor: 'pointer'
            }}
            type="button"
          >
            Back
          </button>
        </div>
      </body>
    </html>
  );
}
